import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown, Menu, X } from 'lucide-react';

const Navbar = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);

  const services = [
    { id: 'aile-hukuku', name: 'Aile ve Boşanma Hukuku' },
    { id: 'yabancilar-hukuku', name: 'Yabancılar Hukuku' },
    { id: 'ceza-hukuku', name: 'Ceza Hukuku' },
    { id: 'sigorta-hukuku', name: 'Sigorta Hukuku' },
    { id: 'gayrimenkul-hukuku', name: 'Gayrimenkul Hukuku' },
    { id: 'yapay-zeka-hukuku', name: 'Yapay Zeka ve Bilişim Hukuku' },
    { id: 'is-hukuku', name: 'İş Hukuku' },
    { id: 'ticaret-hukuku', name: 'Ticaret Hukuku' },
  ];

  const isActive = (path) => location.pathname === path;
  const isServiceActive = location.pathname.startsWith('/hizmetler');

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-sm">
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between">

          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img 
              src="https://customer-assets.emergentagent.com/job_avukat-portal-6/artifacts/occ791mb_image.png"
              alt="Avukat Zeynep Gür"
              className="h-12 md:h-16 w-auto transform group-hover:scale-105 transition-transform duration-300"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">

            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 ${
                isActive('/') ? 'text-[#997938]' : 'text-white hover:text-[#997938]'
              }`}
            >
              Ana Sayfa
            </Link>

            <Link
              to="/hakkimizda"
              className={`text-sm font-medium transition-colors duration-200 ${
                isActive('/hakkimizda') ? 'text-[#997938]' : 'text-white hover:text-[#997938]'
              }`}
            >
              Hakkında
            </Link>

            {/* HİZMETLER DROPDOWN (DESKTOP) */}
            <div className="relative group">
              <button
                className={`text-sm font-medium transition-colors duration-200 flex items-center space-x-1 ${
                  isServiceActive ? 'text-[#997938]' : 'text-white hover:text-[#997938]'
                }`}
              >
                <span>Hizmetler</span>
                <ChevronDown className="w-4 h-4" />
              </button>

              {/* SADECE DESKTOP → ORTAYA AÇILAN MENÜ */}
              <div
                className="
                  hidden md:block
                  absolute top-full left-1/2 -translate-x-1/2
                  mt-2 w-96 max-w-[90vw]
                  bg-zinc-900/95 backdrop-blur-sm rounded-lg shadow-xl
                  opacity-0 invisible
                  group-hover:opacity-100 group-hover:visible
                  transition-all duration-300 transform origin-top scale-95 group-hover:scale-100
                "
              >
                <div className="py-2">
                  {services.map((service) => (
                    <Link
                      key={service.id}
                      to={`/hizmetler/${service.id}`}
                      className="block px-4 py-2 text-sm text-white hover:bg-gray-700/30 hover:text-[#997938] transition-colors duration-200"
                    >
                      {service.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            <Link
              to="/iletisim"
              className={`text-sm font-medium transition-colors duration-200 ${
                isActive('/iletisim') ? 'text-[#997938]' : 'text-white hover:text-[#997938]'
              }`}
            >
              İletişim
            </Link>

          </div>

          {/* MOBILE MENU BUTTON */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>

        </div>

        {/* ✅ MOBILE MENU (EKSİ HALİNE DÖNDÜ) */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-700">
            <div className="flex flex-col space-y-4 pt-4">

              <Link
                to="/"
                className={`text-sm font-medium ${
                  isActive('/') ? 'text-[#997938]' : 'text-white'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Ana Sayfa
              </Link>

              <Link
                to="/hakkimizda"
                className={`text-sm font-medium ${
                  isActive('/hakkimizda') ? 'text-[#997938]' : 'text-white'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Hakkında
              </Link>

              {/* ✅ MOBILE SERVICES DROPDOWN (EKSİ HALİYLE GERİ GETİRİLDİ) */}
              <div>
                <button
                  className="text-sm font-medium flex items-center space-x-1 text-white"
                  onClick={() => setIsMobileServicesOpen(!isMobileServicesOpen)}
                >
                  <span>Hizmetler</span>
                  <ChevronDown
                    className={`w-4 h-4 transition-transform ${
                      isMobileServicesOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>

                {isMobileServicesOpen && (
                  <div className="mt-2 ml-4 space-y-2">
                    {services.map((service) => (
                      <Link
                        key={service.id}
                        to={`/hizmetler/${service.id}`}
                        className="block text-sm text-gray-300 hover:text-[#997938]"
                        onClick={() => {
                          setIsMobileMenuOpen(false);
                          setIsMobileServicesOpen(false);
                        }}
                      >
                        {service.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link
                to="/iletisim"
                className={`text-sm font-medium ${
                  isActive('/iletisim') ? 'text-[#997938]' : 'text-white'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                İletişim
              </Link>

            </div>
          </div>
        )}

      </div>
    </nav>
  );
};

export default Navbar;

